import React, { useEffect } from 'react';
import { myDataAnalytics } from '@/analytics/myData';
import MyDataHandler from '../MyDataHandler/MyDataHandler';

const MyDataWrapper = () => {
  useEffect(() => {
    myDataAnalytics.accessMyDataPage();
  }, []);

  return (
    <MyDataHandler />
  );
};

export default MyDataWrapper;
